import React, { useState, useEffect } from 'react';
import HomePageSlider from "../../components/homepageslider/HomePageSlider";
import MainContent from "../../components/maincontent/MainContent";
import TitleSubtitle from "../../components/titlesubtitle/TitleSubtitle";
import QAComponents from "../../components/qaComponents/QAComponents";
import ObjectRegisterMain from "../../components/ObjectRegisteryMain/PartnerOrganisations";
import { useTranslation } from "react-i18next";
import HomePageLoader from "./HomePageLoader";

const HomePage = () => {
    const [slides, setSlides] = useState([]);
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [newsData, setNewsData] = useState([]);

    const removeHtmlAndEntities = (text) => {
        const regex = /(<([^>]+)>)/ig;
        const textWithoutHtml = text.replace(regex, '');
        return textWithoutHtml.replace(/&nbsp;/gi, ' ');
    };

    useEffect(() => {
        let isMounted = true;

        const fetchNews = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/GetAllNews`);
                const data = await response.json();
                const cleanNewsData = data.data
                    .filter(news => !news.isTemplate)
                    .map(news => ({
                        ...news,
                        description: removeHtmlAndEntities(news.descriptionShort ? news.descriptionShort : news.description ),
                        descriptionEng: removeHtmlAndEntities(news.descriptionShortEng ? news.descriptionShortEng : news.descriptionEng),
                        title: removeHtmlAndEntities(news.title)
                    }));
                setNewsData(cleanNewsData);
            } catch (error) {
                console.error("Failed to fetch news data:", error);
            }
        };


        const fetchData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/GetAllMainPage`);
                const data = await response.json();
                if (data.success && isMounted) {
                    const sorted = [...data.data].sort((a, b) => {
                        if (a.position == null) return 1;
                        if (b.position == null) return -1;
                        return a.position - b.position;
                    });

                    const formattedSlides = sorted.map(item => ({
                        title: item.title,
                        titleEng: item.titleEng,
                        description: item.descriptionShort,
                        descriptionEng: item.descriptionShortEng,
                        buttonText: item.description ? item.description : 'ახალი ამბები',
                        buttonTextEng: item.descriptionEng ? item.descriptionEng : 'News',
                        backgroundImage: item.path.trim(),
                        locationPath: item.locationPath ? item.locationPath : 'news',
                    }));

                    setSlides(formattedSlides);
                }
            } catch (error) {
                console.error("Failed to fetch main page data:", error);
            }
        };


        const loadData = async () => {
            await Promise.all([fetchData(), fetchNews()]);
            setTimeout(() => {
                if (isMounted) {
                    setIsLoading(false);
                }
            }, 120);
        };

        void loadData();

        return () => {
            isMounted = false;
        };
    }, []);




    return (
        <div>
            <div className="partner-container">
                {isLoading ? (
                    <HomePageLoader />
                ) : (
                    <>
                        <HomePageSlider slides={slides} isLoading={isLoading} />
                        {newsData.length !== 0 && <MainContent newsData={newsData} />}
                    </>
                )}
                <TitleSubtitle
                    titleText={
                        <>
                            {t("დამატებითი კითხვისა და")} <br />
                            {t("დახმარებისთვის")}
                        </>
                    }
                    subtitleText={t("აირჩიე შესაბამისი ბმული")}
                />
                <QAComponents />
                <TitleSubtitle
                    titleText={
                        <>
                            {t("ტექნიკური და სამშენებლო")} <br />
                            {t("ზედამხედველობის სააგენტო")}
                        </>
                    }
                    subtitleText={t("პარტნიორი ორგანიზაციები")}
                />
                <ObjectRegisterMain />
            </div>
        </div>
    );
};

export default HomePage;
